import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { NewsService } from '../news.service';
import { NewsItemComponent } from '../news-item/news-item.component';
import { AddButtonComponent } from '../../../shared/components/add-button/add-button.component';

@Component({
  selector: 'app-news-list',
  imports: [NewsItemComponent, AddButtonComponent],
  templateUrl: './news-list.component.html',
  styleUrl: './news-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsListComponent {
  readonly #router = inject(Router);
  readonly #newsService = inject(NewsService);

  /** undefined while loading, then the company's news (live) */
  protected readonly news = toSignal(this.#newsService.getCompanyNews());

  protected navigateToEditor(): void {
    this.#router.navigate(['/main/news/editor']);
  }
}
